import { IParams } from './interfaces/params';

export default function isValidParamsForRegister(params: IParams) {
    return params.cloudrpa_signup_subdomain === '/portal_' && params.register_endpoint === '/register';
}
